/**
 * Spring-Loading für Drag-&-Drop (macOS-Verhalten): verweilt der Zeiger beim Ziehen ~500 ms über
 * einem Ziel, „springt" es auf (Sidebar-Ordner aufklappen, Content-Ordner hineinnavigieren), damit
 * tiefe Ziele ohne Loslassen erreichbar bleiben. Rein die Timer-Mechanik — was beim Aufspringen
 * passiert, entscheidet der Aufrufer per `onSpring`.
 */
import { useEffect, useRef } from 'react';

const SPRING_DELAY_MS = 500;

export function useSpringLoad() {
  const springTimer = useRef<ReturnType<typeof setTimeout> | null>(null);
  const springKey = useRef<string | null>(null);

  function cancelSpring() {
    if (springTimer.current) clearTimeout(springTimer.current);
    springTimer.current = null;
    springKey.current = null;
  }

  /** Plant das Aufspringen von `key` nach der Verweildauer; erneutes Überfahren desselben Ziels
   *  setzt den Timer nicht zurück (sonst feuert er nie), ein anderes Ziel schon. */
  function scheduleSpring(key: string, onSpring: () => void) {
    if (springKey.current === key) return;
    cancelSpring();
    springKey.current = key;
    springTimer.current = setTimeout(() => {
      springTimer.current = null;
      springKey.current = null;
      onSpring();
    }, SPRING_DELAY_MS);
  }

  // Hängenden Timer beim Unmount räumen (kein Spring nach Verlassen der Ansicht).
  useEffect(() => cancelSpring, []);

  return { scheduleSpring, cancelSpring };
}
